'use client';

import type { EnglishIqMessagesType } from './english-iq-messages-type';

interface IEnglishIqStartCardProps {
  actionLabel: string;
  errorBody: string | null;
  errorTitle: string | null;
  isBusy: boolean;
  messages: EnglishIqMessagesType;
  onStart: () => void;
}

export function EnglishIqStartCard({
  actionLabel,
  errorBody,
  errorTitle,
  isBusy,
  messages,
  onStart,
}: IEnglishIqStartCardProps): React.JSX.Element {
  return (
    <div className="mx-auto max-w-xl py-4 text-center sm:py-8">
      <div className="mx-auto grid size-24 place-items-center rounded-[2rem] bg-gradient-to-br from-violet-600 to-cyan-500 text-3xl font-black text-white shadow-2xl shadow-violet-500/20">
        IQ
      </div>
      {errorTitle && errorBody ? (
        <>
          <h1 className="mt-8 text-3xl font-semibold tracking-tight">{errorTitle}</h1>
          <p className="mt-3 text-muted-foreground">{errorBody}</p>
        </>
      ) : (
        <>
          <h1 className="mt-8 text-3xl font-semibold tracking-tight">
            {messages.hero.title} {messages.hero.accent}
          </h1>
          <p className="mt-3 text-muted-foreground">{messages.hero.proof}</p>
        </>
      )}
      <button
        type="button"
        disabled={isBusy}
        onClick={onStart}
        className="mt-8 min-h-12 rounded-full bg-foreground px-8 py-4 font-semibold text-background shadow-lg transition hover:-translate-y-0.5 hover:shadow-xl disabled:cursor-wait disabled:opacity-60 motion-reduce:transform-none motion-reduce:transition-none"
      >
        {isBusy ? messages.wizard.preparing : actionLabel}
      </button>
    </div>
  );
}
